import { render } from "./CasesPage.vue?vue&type=template&id=73de6648&scoped=true"
import script from "./CasesPage.vue?vue&type=script&lang=js"
export * from "./CasesPage.vue?vue&type=script&lang=js"

import "./CasesPage.vue?vue&type=style&index=0&id=73de6648&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73de6648"]])

export default __exports__